export const QM_LIST_ROLES = ['QM_LIST_NO_ACCESS', 'QM_LIST_READ_ONLY', 'QM_LIST_EDITABLE'] as const;

export type QmListRoleValue = (typeof QM_LIST_ROLES)[number];

export const DEFAULT_QM_LIST_ROLE: QmListRoleValue = 'QM_LIST_NO_ACCESS';

export function isQmListRoleValue(role: string | null | undefined): role is QmListRoleValue {
  return role === 'QM_LIST_NO_ACCESS' || role === 'QM_LIST_READ_ONLY' || role === 'QM_LIST_EDITABLE';
}

export function toQmListRoleOrNull(role: string | null | undefined): QmListRoleValue | null {
  return isQmListRoleValue(role) ? role : null;
}

export function toQmListRoleValue(role: string | null | undefined): QmListRoleValue {
  if (isQmListRoleValue(role)) return role;

  return DEFAULT_QM_LIST_ROLE;
}

export function getQmListRoleLabel(role: string | null | undefined): string {
  const normalizedRole = toQmListRoleValue(role);

  if (normalizedRole === 'QM_LIST_EDITABLE') return 'Write access to all QMs';
  if (normalizedRole === 'QM_LIST_READ_ONLY') return 'Read all QMs only';

  return 'View own QMs only';
}

export function getQmListRoleShortLabel(role: string | null | undefined): string {
  const normalizedRole = toQmListRoleValue(role);

  if (normalizedRole === 'QM_LIST_EDITABLE') return 'Write All';
  if (normalizedRole === 'QM_LIST_READ_ONLY') return 'Read All';

  return 'Own Only';
}
